import { PostAPI } from 'Components/Helper/Helpers';

export const SenderRegistration = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/SenderRegistration');
};

export const Select = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/Select');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/Add');
};

export const ViewBeneficiary = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/BeneficiarySelect');
};

export const DeleteBeneficiary = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/DeleteBeneficiary');
};

export const BeneficiaryOTPValidate = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/BeneficiaryOTPValidate');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/MoneyTransfer');
};

export const GenerateOTPForMoneyTransfer = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/GenerateOTPForMoneyTransfer');
};

export const GenerateRefundOTP = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/RefundSendOTP');
};

export const GenerateOTPForSender = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/GenerateOTPForSender');
};

export const VerifyOTPForSender = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/VerifyOTPForSender');
};

export const AadhaarBiometricForSender = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/AadhaarBiometricForSender');
};

export const SenderKycSlab = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/GetSenderKycSlab');
};

export const GetSplitAmountForTransaction = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/SplitAmountForTransaction');
};

export const GenerateOTPForSplitAmount = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/GenerateOTPForSplitAmount');
};

export const RefundSendOTP = async (request) => {
    return PostAPI(request, 'NSDLBankDMT/RefundSendOTP');
};